import { ActionIcon, Box, Tooltip } from "@mantine/core";
import type { FC } from "react";

import AppSettings from "src/AppSettings";
import Icon from "src/components/common/Icon";

import { helpTourTargetAttribute } from "src/components/help/HelpTourTarget";
import { insertionTourTarget } from "src/help/helpTourTargets";

import classes from "./ConfigurationInsertionControl.module.scss";

/** Supplies accessible text, availability and the parent-owned insertion callback. */
type ConfigurationInsertionControlProps = {
    ariaLabel: string;
    disabled: boolean;
    tooltip: string;
    onClick: () => void;
};

/**
 * Renders the shared insertion button with its supplied tooltip and disabled state.
 *
 * Postconditions: The button is the tour target named by its accessible label. Clicks delegate to
 * the supplied callback; this control does not choose a rank,
 * mutate a collection or save data itself. Its stylesheet owns hover and placement presentation.
 */
const ConfigurationInsertionControl: FC<ConfigurationInsertionControlProps> = ({
    ariaLabel,
    disabled,
    tooltip,
    onClick
}) => (
    <Box className={classes.insertionControl}>
        <Tooltip label={tooltip}>
            <ActionIcon
                className={classes.insertionButton}
                variant="filled"
                size="sm"
                radius="xl"
                aria-label={ariaLabel}
                {...{ [helpTourTargetAttribute]: insertionTourTarget(ariaLabel) }}
                disabled={disabled}
                onClick={onClick}
            >
                <Icon icon={AppSettings.icons.add} />
            </ActionIcon>
        </Tooltip>
    </Box>
);

export default ConfigurationInsertionControl;
